export default __webpack_public_path__ + "static/media/calendar_logo.2de44f79.png";